import Grid from '../../Common/Grid';
import Cell from '../../Common/Grid/Cell';
import getNoDataCellComponent from '../../Common/NoDataCellComponent';
import styles from './styles';
import React from 'react';
import PersonIcon from '@material-ui/icons/Person';
import { TableFilterRow } from '@devexpress/dx-react-grid-material-ui';
import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import { CONFIRM_DIALOG, EMPLOYEE_DIALOG } from '../../../redux/constants/dialogs';
import AddIcon from '@material-ui/icons/Add';
import { name } from '../../../utils/helper';

const COLUMNS = [
  { name: 'name', title: 'Name' },
  { name: 'mobile', title: 'Mobile' },
  { name: 'email', title: 'Email' },
  { name: 'permissions', title: 'Permissions' },
  { name: 'tags', title: 'Tags' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'name', width: 200 },
  { columnName: 'mobile', width: 100 },
  { columnName: 'email', width: 150 },
  // { columnName: 'action', width: 100 },
];

const renderPermission = (employee, permission) => {
  return (<Chip
    style={styles.chip}
    key={`${employee.id}-${permission}`}
    label={permission}
  />);
};

const renderTag = (employee, tag) => {
  return (<Chip
    style={styles.chip}
    key={`${employee.id}-${tag}`}
    label={tag}
  />);
};

const getCellComponent = (onEdit, onRemove) => ({ row, column, value }) => {
  switch (column.name) {
    case 'name':
      return name(row);
    case 'email':
      return value ? (<a href={`mailto:${value}`}>{value}</a>) : null;
    case 'permissions':
      return (value || []).map((permission) => renderPermission(row, permission));
    case 'tags':
      return (value || []).map((tag) => renderTag(row, tag));
    case 'action':
      return null;
    default:
      return value;
  }

};

const getFilterCellComponent = ({ column, children, ...other }) => {
  switch (column.name) {
    case 'name':
    // case 'mobile':
    // case 'email':
      return (<TableFilterRow.Cell {...other} >{children}</TableFilterRow.Cell>);
    // case 'customerManager':
    //   console.log('other', other);
    //   return (<Cell {...other}>
    //     <EmployeeAutoComplete
    //       value={{}}
    //       onChange={(a, b, c) => console.log('change', a, b, c)}
    //       fetchEmployees={fetchEmployees}
    //     />
    //   </Cell>);
    default:
      return <Cell/>;
  }
};

const handleRemove = (showDialog, onRemove) => (employee) => {
  return new Promise((resolve, reject) => {
    showDialog(CONFIRM_DIALOG, {
      title: 'Are you sure you wish to remove this employee?',
      onConfirm: () => onRemove(employee).then(resolve),
      onReject: reject,
      confirmColor: 'secondary',
    });
  });
}

const EmployeesGrid = ({ data, fetch, onEdit, onRemove, showDialog }) => {
  const buttons = [<Fab
    key="add"
    style={styles.addItem}
    color="secondary"
    onClick={() => {
      showDialog(EMPLOYEE_DIALOG, { employee: {} });
    }}
  >
    <AddIcon/>
  </Fab>];

  return <Grid
    buttons={buttons}
    columns={COLUMNS}
    columnExtensions={COLUMN_EXTENSIONS}
    cellComponent={getCellComponent(onEdit, onRemove)}
    filterCellComponent={getFilterCellComponent}
    fetch={fetch}
    data={data}
    onEdit={onEdit}
    onRemove={handleRemove(showDialog, onRemove)}
    noDataCellComponent={getNoDataCellComponent(<PersonIcon style={styles.noData}/>, 'employees')}
  />;
};

export default EmployeesGrid;



// WEBPACK FOOTER //
// ./src/components/Employees/EmployeesGrid/index.js